import { TKey } from "@/app/translations/TKey";

export const HOME_CTA_STEPS: TKey[] = [
  TKey.HOME_MEIDLY_CTA_STEP_1,
  TKey.HOME_MEIDLY_CTA_STEP_2,
  TKey.HOME_MEIDLY_CTA_STEP_3,
];
